import { render, staticRenderFns } from "./cxgz.vue?vue&type=template&id=a632e9ec&scoped=true&"
import script from "./cxgz.vue?vue&type=script&lang=js&"
export * from "./cxgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a632e9ec",
  null
  
)

export default component.exports